(function ($, Cobalt, undefined) {
    var timePresets;

    Cobalt.UI = {
        CensoredWords: [{}],
        initialize: function () {
            $('.accordion').accordion({
                clearStyle: true,
                autoHeight: false
            });

            // Footer links
            if ($(".t-footer-browse").length > 0) {
                $(".t-footer-browse").delegate(".j-footer-item > a", "click", function (e) {
                    e.preventDefault();
                    var parent = $(this).closest(".t-footer-browse");
                    parent.find(".j-footer-item ul").removeClass("j-list-selected");
                    parent.find(".j-footer-item > a").removeClass("j-selected");
                    $(this).parent().find("ul").addClass("j-list-selected");
                    $(this).addClass("j-selected");
                });
            }

            // Spoiler Tags
            Cobalt.runOnHtmlInsert(Cobalt.UI.bindSpoilers);
        },
        bindSpoilers: function () {
            $(".spoiler").each(function () {
                var spoiler = $(this);
                spoiler.prev().remove(".spoiler-button-wrapper"); //remove the wrapper if it exists
                var spoilerLabel = "Spoiler";
                if (spoiler.attr("data-spoiler-title") != null && spoiler.attr("data-spoiler-title").length) {
                    spoilerLabel = spoiler.attr("data-spoiler-title");
                    if (spoilerLabel) {
                        spoilerLabel = Cobalt.UI.processCensorship(spoilerLabel);
                    }
                }
                var spoilerButtonWrapper = $("<div>").addClass("spoiler-button-wrapper");
                var spoilerButton = $("<a>").text(spoilerLabel + ' (click to show)').addClass("button").click(function () {
                    if (spoiler.isVisible()) {
                        $(this).text(spoilerLabel + ' (click to show)');
                        spoiler.hide();
                    } else {
                        $(this).text(spoilerLabel + ' (click to hide)');
                        spoiler.css("display", "block");
                    }
                    return false;
                });
                spoilerButtonWrapper.append(spoilerButton);
                spoiler.before(spoilerButtonWrapper);
            });
        },
        processCensorship: function(content) {
            for (var val in Cobalt.UI.CensoredWords) {
                var censoredWord = Cobalt.UI.CensoredWords[val].CensoredWord;
                if (censoredWord) {
                    var replacement = "";
                    for (var i = 0; i < censoredWord.length; i++) {
                        replacement += '*';
                    }
                    var escapedWord = censoredWord.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                    var regex = new RegExp(escapedWord, "gi");
                    content = content.replace(regex, replacement);
                }
            }
            return content;
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.UI.js